import React from 'react';
import { Button } from 'antd';
import { connect } from 'react-redux';

import { MISSING_GO_BACK_TO_DASH } from '../../config/media';
import { MoveToKitWrapper } from './style';

const MoveToKit = ({ exchange }) => {
    return (
        <MoveToKitWrapper>
            <div className="content">
                To view this page you must go to your exchange's operator control panel
            </div>
            <img
                src={MISSING_GO_BACK_TO_DASH}
                alt="goback to dash"
                className="master-admin-img"
            />
            <div className="btn-wrapper">
                {exchange.domain && exchange.is_running
                    ? <a href={`${exchange.domain}/admin`} target="_blank" rel="noopener noreferrer">
                        <Button type="primary">Go to operator control</Button>
                    </a>
                    : <Button type="primary" disabled>Go to operator control</Button>
                }
            </div>
        </MoveToKitWrapper>
    );
};

const mapStateToProps = (state) => ({
    exchange: state.exchange && state.exchange.length
        ? state.exchange[0]
        : {}
});

export default connect(mapStateToProps)(MoveToKit);
